import styled from "styled-components";
import { Button as AntButton } from 'antd';

export const RootContainer = styled.div`
	padding: 24px 16px 16px 16px;
	height: calc(100vh - 176px);
	overflow-y: auto;
`;

export const Loader = styled.div`
height: calc(100vh - 136px);
display: flex;
align-items: center;
justify-content: center;
`;

export const EmptyBox = styled.div`
height: calc(100vh - 136px);
    display: flex;
    flex-direction: column;
    gap: 6px;
    align-items: center;
    justify-content: center;

    svg {
        font-size: 24px;
        color: #808080;
    }
`;

export const EmptyText = styled.div`
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #808080;
`;

export const Item = styled.div`
	margin-bottom: 16px;
`;

export const Divider = styled.div`
width: 100%;
height: 1px;
background: #E5E0F5;
`;

export const LightText = styled.div`
	color: #2A2A2A;
	font-size: 16px;
	font-style: normal;
	font-weight: 300;
	line-height: 26px; /* 162.5% */
`;

export const StatusBox = styled.div`
	padding: 5px 10px;
	border-radius: 100px;
	display: inline;
	background: ${props => props.isPending === "true" ? "#D69A00" :  "#12A132"};

	color:  ${props => props.isPending === "true" ? "#FBF5E6" :  "#E8FBEC"};
	font-size: 10px;
	font-style: normal;
	font-weight: 700;
	line-height: 20px; /* 200% */
`;

export const Button = styled(AntButton)`
	height: 55px;
	width: calc(100% - 32px);
	max-width: 448px;
	margin-left: 16px;
`;

export const TopBox = styled.div`
	padding: 16px;
	margin-bottom: 24px;
	border-radius: 8px;
	background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);

	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const BoldText = styled.p`
	color: #2A2A2A;
	text-align: right;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 26px; /* 162.5% */
`

export const Box = styled.div`
	border-radius: 8px;
	background: #FFF;
	box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.10);
	padding: 16px;

	position: relative;

	display: flex;
	flex-direction: column;
	gap: 12px;

	.ant-space .ant-space-item {
			flex: 1;
	}
`